import AbakalikiRice from "../assets/rice.jpg";
import Ofada from "../assets/ofada.jpg";
import Beans from "../assets/beans.jpg";
import Semo from "../assets/semo.jpg";
import Gari from "../assets/gari.jpg";
import Yamflour from "../assets/elubo.jpg";

export const MenuList = [
  {
    name: "Abakaliki Rice",
    image: AbakalikiRice,
    price: "19,500",
  },
  {
    name: "Ofada Rice",
    image: Ofada,
    price: "15,800",
  },
  {
    name: "Oloyin Bean",
    image: Beans,
    price: "2,000",
  },
  {
    name: "Semo",
    image: Semo,
    price: "8,100",
  },
  {
    name: "Gari Ijebu",
    image: Gari,
    price: "14,350",
  },
  {
    name: "Yam Flour (Elubo)",
    image: Yamflour,
    price: "6,000",
  },
];

export default MenuList